import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Outlet } from 'react-router'

import { useGetUserWithTokenQuery } from '../../services/apiSlice'
import Spinner from '../../components/loading/Spinner'

const TokenCheckpoint: React.FC = () => {
  const navigate = useNavigate()

  const { data, isSuccess, isLoading, isError } = useGetUserWithTokenQuery(
    undefined,
    {
      refetchOnMountOrArgChange: false,
    },
  )

  useEffect(() => {
    if (isError) {
      navigate('/', { replace: true })
    }
  }, [isError, navigate])

  const loadingComponent = (
    <div className="flex h-dvh w-dvw items-center justify-center">
      <Spinner />
    </div>
  )

  return (
    <div className="flex h-full w-full">
      {isLoading && loadingComponent}
      {isError && loadingComponent}
      {isSuccess && data && <Outlet context={data} />}
    </div>
  )
}

export default TokenCheckpoint
